//BrokerManagement roles are static and they wont be changing .
export const brokerAdminRoleId = 'd88de0bd-7eac-4b47-b81b-a403c0390af4';
